export const FETCH_POSTS = 'FETCH_POSTS';
export const CREATE_POST = 'CREATE_POST';
export const DELETE_POST = 'DELETE_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const GET_POST = 'GET_POST';
export const GET_FEED = 'GET_FEED';
export const GET_TAGS = 'GET_TAGS';